import * as z from "zod";
import {
  AppleMessagesBusinessLinkSchema,
  appleMessagesBusinessIdSchema,
} from "./apple-messages-business-link";

export const linkAppleMessagesBusiness = {
  name: "linkAppleMessagesBusiness" as const,
  input: z.object({
    businessId: appleMessagesBusinessIdSchema,
    /** As Apple passes them on the landing-page URL; absent for test accounts. */
    name: z.string().max(200).nullable(),
    logoUrl: z.string().url().max(2000).nullable(),
  }),
  output: z.object({ link: AppleMessagesBusinessLinkSchema }),
};
